//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "MayoScore",
  data() {
    return {
      form: {
        NumberOfStools: "",
        hematochezia: "",
        endoscopic: "",
        physicianEvaluation: "",
      },
      spcile:false,
      hasScore: false,
      disabled: false,
      dataList1: [
        { value: "0", name: "排便次数正常" },
        { value: "1", name: "比正常排便次数增加1-2 次／d" },
        { value: "2", name: "比正常排便次数增加3-4次/d" },
        { value: "3", name: "比正常排便次数增加5次/d或以上" },
      ],
      dataList2: [
        { value: "0", name: "未见出血" },
        { value: "1", name: "不到一半时间内出现便中混血" },
        { value: "2", name: "大部分时间内为便中混血" },
        { value: "3", name: "一直存在出血" },
      ],
      dataList3: [
        { value: "0", name: "正常或无活动性病变" },
        { value: "1", name: "轻度病变（红斑、血管纹理减少、轻度易脆）" },
        { value: "2", name: "中度病变（明显红斑、血管纹 理缺乏、易脆、糜烂）" },
        { value: "3", name: "重度病变（自发性出血，溃疡形成）" },
      ],
      dataList4: [
        { value: "0", name: "正常" },
        { value: "1", name: "轻度病情" },
        { value: "2", name: "中度病情" },
        { value: "3", name: "重度病情" },
      ],
     
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      let result = 0;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
            if(form[key] > 1) {
              this.spcile = true
            }
          }
        }
        result += Number(form[key]);
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/MayoScore.vue